<template>
  <div>
    <QS-h3-title v-if="!bizId" title="维保方案详情"  has-bottom-line />
    <basicInformation :list="list" :source="source"/>
    <comboProduct :packageList="packageList"/>
  </div>
</template>

<script>
import basicInformation from './components/maintenancePlan/basicInformation'
import comboProduct from './components/maintenancePlan/comboProduct'
import { maintenancePlanDetail } from '@/api/serviceAPi'
import config from './config'
import selectOption from '@/store/dict/selectOptionDict'

const { planState, list } = config
export default {
  name: 'maintenancePlanDetail',
  components: {
    basicInformation,
    comboProduct,
  },
  data() {
    return {
      list,
      packageList: [],
      source: null,
      bizId: '',
    }
  },

  methods: {
    // 处理方案详情数据
    setPlanData(data) {
      // 维保类型
      const maintenanceTypList = selectOption.maintenanceTypeDict
      // 套餐信息
      const { packageList } = data
      // 方案状态
      const planItem = planState.find((item) => item.value === data.state)
      data.stateName = planItem && planItem.label || ''
      console.log('packageList ===>', packageList)
      if (!packageList) return
      packageList?.map((item) => {
        item.maintenanceTypeName = maintenanceTypList[item.maintenanceType]
        // 套餐类型名称
        item.packageTypeName = item.packageType === 10 ? '多次核销' : '商品池'
        item.packageUseList.map((offItem, index) => {
          offItem.goodsList.map((good) => {
            good.workAmount = offItem.workAmount
            good.num = index + 1
          })
        })
      })
      this.packageList = packageList
      this.source = data
    },

    // 获取方案详情
    async getPlanDetail() {
      const { id, bizType, bizId } = this.$route.query
      this.bizId = bizId
      const paramsId = bizType ? bizId : id
      const { code, data } = await maintenancePlanDetail({ id: paramsId })
      console.log('data ===>', data)
      if (code === 1) {
        this.setPlanData(data)
      }
    },
  },
  created() {
    this.getPlanDetail()
  },
}
</script>

<style>

</style>
